import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { CHECKOUT_URL } from '../config';
/**
 * Floating CTA that appears once the user scrolls past the first (hero) CTA.
 * It watches an element with id="hero-cta" and shows after it leaves the viewport.
 */
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const anchor = document.getElementById('hero-cta');
    if (!anchor) return;
    const observer = new IntersectionObserver(([entry]) => {
      // Show only after the hero CTA has scrolled out of view (upwards).
      setVisible(!entry.isIntersecting && entry.boundingClientRect.top < 0);
    }, {
      threshold: 0
    });
    observer.observe(anchor);
    return () => observer.disconnect();
  }, []);
  return <AnimatePresence data-id="element-97">
      {visible && <motion.div initial={{
      y: 100,
      opacity: 0
    }} animate={{
      y: 0,
      opacity: 1
    }} exit={{
      y: 100,
      opacity: 0
    }} transition={{
      type: 'spring',
      stiffness: 300,
      damping: 28
    }} className="fixed inset-x-0 bottom-0 z-50 px-3 pb-3" data-id="element-98">
          <div className="mx-auto max-w-md rounded-2xl bg-white/80 p-1.5 shadow-2xl ring-1 ring-brand-purple/10 backdrop-blur" data-id="element-99">
            <a href={CHECKOUT_URL} className="animate-pulse-ring flex w-full items-center justify-center gap-2 rounded-xl bg-brand-pink px-4 py-3.5 text-center text-sm font-extrabold uppercase leading-tight text-white sm:text-base" data-id="element-100">
              Quiero corregir evaluaciones en 30 min
            </a>
          </div>
        </motion.div>}
    </AnimatePresence>;
}